import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Contact, ContactPerson } from '../models/contact';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  constructor(private http: HttpClient) {}

  getContacts() {
    return this.http.get<Contact[]>(`${environment.apiUrl}/supportContacts`).pipe(
      map(response =>
        response.map(res => {
          return {
            ...res,
            contacts: res.contacts.map(contact => ({ ...contact, address: this.commaSeparated(contact) }))
          };
        })
      )
    );
  }

  private commaSeparated(contact: ContactPerson) {
    return contact.address?.replace(/[\r\n]+/g, ', ') || null;
  }
}
